// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Buhta_landing__Link from "../../../components/html/Link.js";
import * as Buhta_landing__LinkToCabinet from "../../../components/html/LinkToCabinet.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function NavbarCabinetMenuMobile(Props) {
  let theme = Props.theme;
  let onLogout = Props.onLogout;
  let identity = Props.identity;
  let cabinetMenuActive = Props.cabinetMenuActive;
  let setCabinetMenuActive = Props.setCabinetMenuActive;
  let setMobileMenuActive = Props.setMobileMenuActive;
  const country = Buhta_landing__Route.getCountry(undefined);
  const language = Buhta_landing__Route.getLanguage(undefined);
  const intl = ReactIntl.useIntl();
  let tmp;
  if (cabinetMenuActive) {
    const __x = identity.tenants;
    const operator_tenant = Belt__Belt_List.getBy(__x, (function (tenant) {
      return tenant.tenant_type === "operator";
    }));
    tmp = JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(Buhta_landing__LinkToCabinet.make, {
          route: /* OrgChoose */ 0,
          className: "py-2.5 flex justify-between",
          onLinkClicked: (function (param) {
            Curry._1(setCabinetMenuActive, (function (param) {
              return false;
            }));
          }),
          children: JsxRuntime.jsx("p", {
            children: "Кабинет",
            className: "paragraph-large text-black-landing"
          })
        }),
        JsxRuntime.jsx("hr", {
          className: "text-divider"
        }),
        operator_tenant !== undefined ? JsxRuntime.jsxs(React.Fragment, {
            children: [
              JsxRuntime.jsx(Buhta_landing__LinkToCabinet.make, {
                route: {
                  TAG: /* Admin */ 7,
                  _0: /* Main */ 0
                },
                className: "py-2.5 flex justify-between",
                onLinkClicked: (function (param) {
                  Curry._1(setCabinetMenuActive, (function (param) {
                    return false;
                  }));
                }),
                children: JsxRuntime.jsx("p", {
                  children: Buhta_landing__I18n.transComponent(intl, "admin_cab"),
                  className: "paragraph-large text-black-landing"
                })
              }),
              JsxRuntime.jsx("hr", {
                className: "text-divider"
              })
            ]
          }) : null,
        JsxRuntime.jsx(Buhta_landing__Link.make, {
          route: {
            TAG: /* Landing */ 0,
            _0: country,
            _1: language,
            _2: /* Home */ 0
          },
          className: "py-2.5 flex justify-between",
          onLinkClicked: (function (param) {
            Curry._1(setCabinetMenuActive, (function (param) {
              return false;
            }));
          }),
          children: JsxRuntime.jsx("p", {
            children: "Настройки",
            className: "paragraph-large text-black-landing"
          })
        }),
        JsxRuntime.jsx("hr", {
          className: "text-divider"
        }),
        JsxRuntime.jsx(Buhta_landing__Link.make, {
          route: {
            TAG: /* Landing */ 0,
            _0: country,
            _1: language,
            _2: /* Home */ 0
          },
          className: "py-2.5 flex justify-between",
          onLinkClicked: (function (param) {
            Curry._1(setCabinetMenuActive, (function (param) {
              return false;
            }));
          }),
          children: JsxRuntime.jsx("button", {
            children: JsxRuntime.jsx("p", {
              children: "Выход",
              className: "paragraph-large text-black-landing text-left"
            }),
            className: "w-full",
            onClick: (function (param) {
              Curry._1(onLogout, undefined);
            })
          })
        }),
        JsxRuntime.jsx("hr", {
          className: "text-divider"
        }),
        JsxRuntime.jsxs("span", {
          children: [
            JsxRuntime.jsx("img", {
              className: "mr-2",
              src: StaticAsset.src("/static/icons/tickets.svg")
            }),
            Buhta_landing__I18n.trans(intl, "help_center")
          ],
          className: "paragraph-small mt-6 flex py-3.5 text-gray-landing cursor-pointer border-b border-divider hover:text-primary transition-all duration-200 ease-in-out"
        }),
        JsxRuntime.jsxs("span", {
          children: [
            JsxRuntime.jsx("img", {
              className: "mr-2",
              src: StaticAsset.src("/static/icons/question.svg")
            }),
            Buhta_landing__I18n.trans(intl, "how_to_work_with_buhta")
          ],
          className: "paragraph-small flex py-3.5 text-gray-landing cursor-pointer border-b border-divider hover:text-primary transition-all duration-200 ease-in-out"
        }),
        JsxRuntime.jsxs(Buhta_landing__Link.make, {
          route: {
            TAG: /* Landing */ 0,
            _0: country,
            _1: language,
            _2: /* Contact */ 7
          },
          className: "paragraph-small flex py-3.5 text-gray-landing cursor-pointer border-b border-divider hover:text-primary transition-all duration-200 ease-in-out",
          children: [
            JsxRuntime.jsx("img", {
              className: "mr-2",
              src: StaticAsset.src("/static/icons/at.svg")
            }),
            Buhta_landing__I18n.trans(intl, "contacts")
          ]
        })
      ],
      className: "fixed top-26 bottom-0 left-0 w-screen bg-white px-6 overflow-y-scroll pt-4 z-10"
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx("div", {
        children: cabinetMenuActive ? JsxRuntime.jsx("img", {
            className: "w-6",
            src: StaticAsset.src("/static/icons/avatar.svg")
          }) : (
            theme === "dark" ? JsxRuntime.jsx("img", {
                alt: "avatar white",
                src: StaticAsset.src("/static/icons/avatar-white.svg")
              }) : JsxRuntime.jsx("img", {
                alt: "avatar black",
                src: StaticAsset.src("/static/icons/avatar-black.svg")
              })
          ),
        onClick: (function (param) {
          Curry._1(setCabinetMenuActive, (function (param) {
            return !cabinetMenuActive;
          }));
          Curry._1(setMobileMenuActive, (function (param) {
            return false;
          }));
        })
      }),
      tmp
    ]
  });
}

const make = NavbarCabinetMenuMobile;

export {
  make,
}
/* Buhta_landing__Link Not a pure module */
